import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-urgency text-white py-3 px-4 shadow-md" data-id="element-116">
      <div className="max-w-4xl mx-auto text-center text-sm md:text-base font-medium" data-id="element-117">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-118">
          ⏳ FASE BETA: Accede hoy por solo{' '}
          <span className="text-gold-light font-bold" data-id="element-119">$6.36</span> antes de que
          el precio suba a{' '}
          <span className="text-gold-light font-bold line-through opacity-80" data-id="element-120">
            $37
          </span>
          . ¡Solo para los primeros 50 fundadores!
        </motion.span>
      </div>
    </div>;
}